module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMyIiBjbGFzcz0ib2N0aWNvbiBvY3RpY29uLXN0YXIiIHZpZXdCb3g9IjAgMCAxNCAxNiIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjgiIGFyaWEtaGlkZGVuPSJ0cnVlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0ZGQUMyQyIgZD0iTTE0IDZsLTQuOS0uNjRMNyAxIDQuOSA1LjM2IDAgNmwzLjYgMy4yNkwyLjY3IDE0IDcgMTEuNjcgMTEuMzMgMTRsLS45My00Ljc0eiI+PC9wYXRoPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/components/star.svg
// module id = 643
// module chunks = 230186691558513